import type { CSSProperties } from 'react';
import type { SlateElementAttributes, CustomElement } from 'types/slate';

import { getStyle } from '../utils';

interface NumberdListElement extends CustomElement {
  listStyleType: 'decimal' | 'lower-alpha' | 'lower-roman';
}

export type NumberedListProps = {
  children: any;
  element: NumberdListElement;
  annotation?: any;
  attributes?: SlateElementAttributes;
};

export const NumberedList = ({ attributes, element, children }: NumberedListProps) => {
  const style: CSSProperties = getStyle(element);

  if (element.listStyleType) {
    style.listStyleType = element.listStyleType;
  }

  return (
    <ol {...attributes} style={style}>
      {children}
    </ol>
  );
};
